import { Component, HostListener } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-landing-page-header',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './landing-page-header.component.html',
  styleUrl: './landing-page-header.component.scss',
})
export class LandingPageHeaderComponent {
  isMobileMenuOpen = false;

  constructor(private router: Router, private authService: AuthService) {}

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.public-mobile-header')) {
      this.isMobileMenuOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  closeOpenMenus(): void {
    this.isMobileMenuOpen = false;
  }

  toggleMobileMenu(event: Event) {
    event.stopPropagation();
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  get homeRoute(): string {
    return this.authService.getLogflag() ? '/portal' : '/';
  }

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: this.router.url === this.homeRoute ? 'smooth' : 'auto',
    });
  }
}
